import React, { useEffect, useRef } from "react";
import ApexCharts from "apexcharts";
import { statusData } from "./dataColor";
import { attachPdfMenu } from "./chartPdf";

const OrdersColumnChart = (props) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const defaultSeries = [{ name: "", data: [] }];
    const defaultCategories = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const seriesData = props?.chartdata?.series || defaultSeries;
    const categoriesData = props?.chartdata?.categories || defaultCategories;
    const colors = seriesData.map((series) => {
      const status = statusData.find((item) => item.message === series.name);
      return status?.color || "#808080";
    });

    let options = {
      series: seriesData,
      chart: {
        type: "bar",
        height: 350,
        redrawOnParentResize: false,
        redrawOnWindowResize: false,
        animations: { enabled: false },
        toolbar: { show: true },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "80%",
          borderRadius: 5,
          borderRadiusApplication: "end",
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      colors: colors, // Use the dynamically generated colors array
      dataLabels: {
        enabled: true,
        formatter: function (val) {
          return val === 0 ? "" : val;
        },
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#304758"],
        },
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: categoriesData,
      },
      // yaxis: {
      //   title: {
      //     text: "$ (thousands)",
      //   },
      // },
      fill: {
        opacity: 1,
      },
      tooltip: {
        theme: "light",
        fillSeriesColor: false,
        y: {
          formatter: function (val) {
            return "Count " + val;
          },
        },
      },
    };

    const chart = new ApexCharts(chartRef.current, options);
    const root = chartRef.current;

    chart.render().then(() => attachPdfMenu(chart, root, props.exportName || "chart"));

    return () => {
      chart.destroy();
    };

  }, [props.chartdata, props.exportName]);

  return <div id={`columnChart-${props?.key}`} ref={chartRef}></div>;
};

export default OrdersColumnChart;
